import type { CollectorsSelect } from '@/types/collectorsSelect';
import type { NftcollectionsSelect } from '@/types/nftcollectionsSelect';

/**
 * Collection fields the site never reads that make catalogue records heavy. A collection's top
 * collectors arrive with each collector's full wallet history: 359 KB of a 387 KB Muraqqa Data
 * Miniatures record, and about 1 MB of every Series page, since the page hands the record to
 * browser components (measured October 2026).
 */
export const LEAN_COLLECTION: NftcollectionsSelect<false> = {
  topCollectors: false,
  guildInventorySnapshot: false,
};

/**
 * The same for records populated inside others, plus an owner's trading stats. A page of 33
 * artworks at depth 2 carried its collection and owner 33 times: 12.2 MB, 835 KB without these.
 * The leaderboard and collector pages read collectors through their own requests.
 */
export const LEAN_POPULATE: { nftcollections: NftcollectionsSelect<false>; collectors: CollectorsSelect<false> } = {
  nftcollections: LEAN_COLLECTION,
  collectors: { tradingStats: false, guildPoints: false },
};
